import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useTypedSelector } from "src/app/store";
import { SearchIcon } from "src/assets/svg";
import CustomInput from "../common/input";

function SearchFilter({
  setSearchValue,
  searchValue,
}: {
  setSearchValue?: (id: string | undefined) => void;
  searchValue?: string;
}) {
  const { t } = useTranslation();
  const { colors } = useTypedSelector((state) => state.layout);

  return (
    <div className="university-search">
      <CustomInput
        controlHeight={56}
        placeholder={t("filters.search")}
        prefix={<SearchIcon color={colors.primary} />}
        onChange={(ev) => {
          if (ev.target.value.length === 0) {
            setSearchValue && setSearchValue(undefined);
          } else {
            setSearchValue && setSearchValue(ev.target.value);
          }
        }}
        value={searchValue}
        allowClear
      />
    </div>
  );
}

export default SearchFilter;
